import { useEffect, useState } from "react";

import { Box, Stack, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import useData from "../../hooks/useData";

const VisibilityDisplay = ({ value }) => {
  const { getMessage, provinces, visibilityFilterName } = useLocalization();

  const { getFromServer, sortByFields } = useData();

  const [retailers, setRetailers] = useState([]);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const retailerList = await getFromServer({ entityName: "Retailer" });
    setRetailers(sortByFields(retailerList, ["name"]));

    const bannerList = await getFromServer({ entityName: "Banner" });
    setBanners(sortByFields(bannerList, ["name"]));
  };

  const getFilterName = (filter) => {
    let record = null;

    switch (filter.name) {
      case "retailer":
        record = retailers.find((retailer) => retailer.id === filter.value);
        break;

      case "banner":
        record = banners.find((banner) => banner.id === filter.value);
        break;

      case "province":
        record = provinces.find((province) => province.id === filter.value);

        break;
    }

    return record ? record.name : "";
  };

  return (
    <>
      {Array.isArray(value) && value.length > 0 ? (
        <Stack>
          {value.map((filter) => (
            <Box
              sx={{ display: "flex" }}
              gap={1}
            >
              <Typography sx={{ fontSize: "10px" }}>
                {visibilityFilterName(filter.name)}
              </Typography>
              <Typography sx={{ fontSize: "10px" }}>:</Typography>
              <Typography sx={{ fontSize: "10px" }}>
                {getFilterName(filter)}
              </Typography>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography sx={{ fontSize: "10px" }}>
          {getMessage("notSet")}
        </Typography>
      )}
    </>
  );
};

export default VisibilityDisplay;
